import React, { FC } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { default as MuiSelect } from '@material-ui/core/Select';
import { default as MuiListSubheader } from '@material-ui/core/ListSubheader';
import { default as MuiMenuItem } from '@material-ui/core/MenuItem';
import { GroupSelectProps } from './types';
import styles, { useCustomOptionStyle, emptyStyles, subheaderStyles } from './style';
import { cx } from '../customEmotion';

const StyledSelect = withStyles(styles)(MuiSelect);
const StyledEmptyLabel = withStyles(emptyStyles)(MuiListSubheader);
const StyledSubheader = withStyles(subheaderStyles)(MuiListSubheader);

const GroupSelect: FC<GroupSelectProps> = (props) => {
  const {
    groups,
    value,
    onChange,
    variant = 'outlined',
    onOpen,
    onClose,
  } = props;

  const classes = useCustomOptionStyle();

  return (
    <StyledSelect
      value={value}
      onChange={onChange}
      variant={variant}
      onOpen={onOpen}
      onClose={onClose}
      displayEmpty
      fullWidth
    >
      {groups.map(group => 
        {
            return (
              [
                <StyledSubheader>
                  {group.groupTitle}
                </StyledSubheader>
              ,
                group.options.map(opt => {
                  if (opt.emptyLabel) {
                    return (
                      <StyledEmptyLabel style={{ pointerEvents: 'none' }}>{opt.emptyLabel}</StyledEmptyLabel>
                    )
                  }
                  return (
                    <MuiMenuItem 
                      className={classes.container}
                      value={opt.value}
                      key={opt.value}
                    >
                      <div
                        className={cx(classes.root, classes[group.optionType])}
                      >
                        {opt.children}
                      </div>
                    </MuiMenuItem>
                  )
                })
              ]
            )
        })
      }
    </StyledSelect>
  );
};

export default GroupSelect;
